<template>
    <div class="el-col el-col-11"> 
        <el-select v-model="code" placeholder="全部">
            <el-option v-for="item in selCodes" :key="item.code" :label="item.name" :value="item.code">
            </el-option>
        </el-select>
        <!-- <el-button @click="get()">点击</el-button> -->
    </div>
</template>
<script>
import { Select} from 'element-ui'
import api from '../../../com/ajax'
import config from '../../../com/config'

export default {
  name: 'app',
    components: {
        Select
    },
    data () {
        return {
            // 对象属性
            selCodes:[],
            code:'',
            orgID:''
        }
    },
    props:{
        code:{
            type:String,
            default:''
        }
    },
    watch:{
        code(val){
                this.$emit('update:value', val)           
        }
    },    
    methods:{
    },
    created:function(){
        var that = this;
        getId.$on('change',function(val){
            that.orgID=val
            api.post(config.khsHost +'base/common/getDictByName.do',{'name':'outcomeType',"orgID":that.orgID}).then(function (response) {

                    if (response.success == true) {

                        that.selCodes = response.body.list
                        that.selCodes.splice(0, 0, { 'id': '', 'name': '全部' })
                    }
              
            })
        })   
    }
}
</script>
<style>
    .el-popper[x-placement^=bottom] .popper__arrow{
        left:50% !important;
    }
</style>


// WEBPACK FOOTER //
// src/components/reports/codeCom/lapse_to.vue?c6160704